import React, { useEffect } from 'react';
import Buttons from '../Common/Buttons';
import { useLocale } from '../../localization/LocaleContext';
import animationFunction from '../Common/animationFunction';
import './FreelancersPage.css';

/* fa-check */
const CheckSvg = () => (
    <svg width="18" height="18" viewBox="0 0 448 512" fill="currentColor" style={{ flexShrink: 0 }}>
        <path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"/>
    </svg>
);

export default function FreelancerCTA() {
    const { t } = useLocale();

    useEffect(() => {
        animationFunction('freelancer-bottom-cta-illustration');
    }, []);

    return (
        <section className="freelancer-bottom-cta sp-90">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-6 mb-4 mb-lg-0">
                        <h2 className="freelancer-bottom-cta-heading">
                            {t('freelancers.bottomCtaTitle')}
                        </h2>
                        <p className="freelancer-bottom-cta-text">
                            {t('freelancers.bottomCtaText')}
                        </p>
                        <Buttons />
                        <div className="freelancer-bottom-cta-ticks mt-30">
                            <div className="tick-item">
                                <CheckSvg />
                                <span>{t('ticks.noCreditCard')}</span>
                            </div>
                            <div className="tick-item">
                                <CheckSvg />
                                <span>{t('ticks.cancelAnytime')}</span>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 d-flex justify-content-center">
                        <img
                            src={`${process.env.PUBLIC_URL}/images/Mask Group 10.png`}
                            className="freelancer-bottom-cta-illustration"
                            alt={t('freelancers.ctaIllustrationAlt')}
                        />
                    </div>
                </div>
            </div>
        </section>
    );
}